import {Switch as BlueprintSwitch} from '@blueprintjs/core/lib/esm/components/forms/controls';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React, {Component} from 'react';
import {
    Intent,
    PopoverInteractionKind,
    Position,
    Popover,
    Callout,
    Tag
} from '@blueprintjs/core';
import {Column, Cell, SelectionModes, RenderMode, Table} from "@blueprintjs/table";
import toastr from 'toastr';
import * as authService from '../../services/authService';
import http from '../../services/httpService';

import {getCurrentUserId, getJwt} from '../../services/authService';
import ReactGA from "react-ga";
import InfoCircle from '../common/InfoCircle';
import CreateTagModal from '../modals/CreateTagModal';
import DeletePhoneModal from '../modals/DeletePhoneModal';
import EditAlphanumericIdModal from '../modals/EditAlphanumericIdModal';
import sizeMe from 'react-sizeme';
import VerifyNumberModal from '../modals/VerifyNumberModal';
import ChartLoader from '../utils/chart-loader';
import Joyride, {STATUS} from "react-joyride";

class SmsChannelSenderPool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: '',
            editSenderNameModal: false,
            selectedTab: 'Active Numbers',
            numbers: [],
            loader: false,
            lastColumnWidth: 1000,
            width: 0,
            deletePhoneId: '',
            showDeletePhoneModal: false,
            pageSize: 5,
            selectedPage: 1,
            totalNumbers: 0,
            selectedSource: '',
            verifyNumberModalActive: false,
            existingNumberData: '',

            //tour setting
            tourRun: this.props.tourRun,
            steps: [
                {
                    content:
                        <div>
                            <h2>Configure your Sender Pool</h2>
                            <p>To be able to send messages the most important thing is setting up the Sender Pool. For
                                some
                                countries Alphanumeric Brand Names are available, while others require you to buy local
                                phone numbers.
                            </p>
                        </div>,
                    placement: 'center',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.sms-pool-tour-step-1',
                },
                {
                    content:
                        <div>
                            <h2>Your Alphanumeric Sender ID</h2>
                            <p>Send messages to your contacts from a personalized ID such as your service or brand name
                                (e.g. "MyAwesomeCompany").
                                By default it is set to be your workspace name, but you can edit it by clicking on the
                                button below.
                            </p>
                            <p>Alphanumeric ID is supported in more than 90 countries.
                            </p>
                        </div>,
                    placement: 'top',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.sms-pool-tour-step-2',
                },
                {
                    content:
                        <div>
                            <h2>Buy Dedicated Phone Numbers</h2>
                            <p>If Alphanumeric ID is not supported, you can still reach out to your contacts in certain
                                countries (e.g. the US, Canada, the UK) using Dedicated Phone Numbers.
                                We advise everyone to purchase at least one US number starting at $1/month.
                            </p>

                        </div>,
                    placement: 'top',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.sms-pool-tour-step-3',

                },
                {
                    content:
                        <div>
                            <h2>Ready to run SMS campaigns?</h2>
                            <p>For countries that support Alphanumeric IDs you can run your campaigns instantly. Sender
                                registration may have additional costs or setup fees depending on the destination
                                country.
                            </p>
                            <p>For international SMS campaigns you should purchase dedicated phone numbers for your
                                campaign destination.
                            </p>

                        </div>,
                    placement: 'center',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.sms-pool-tour-step-4',
                }
            ]
        }
    }

    /* Regular Cell */
    numberCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.numbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>

                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>{item.phone_number || 'No Phone Number'}</p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    numberCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    friendlyNameCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.numbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>

                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>{item.friendly_name || 'No Friendly Name'}</p>
                }
            </div>
        </Cell>
    };


    /* Loading Cell */
    typeCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    threeDotsCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.numbers[rowIndex];

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}} wrapText={true}>{
            this.state.loader ?
                <div className="bp3-skeleton" style={{width: 20, height: 20}}/>
                :
                <div className='flex-end'>
                    <Popover
                        interactionKind={PopoverInteractionKind.CLICK}

                        position={Position.LEFT_TOP}
                        minimal={true}
                    >
                        <span id="feed-edit" className="fas fa-ellipsis-v margin-right-10"></span>
                        <div className="project-info-popover padding-10">
                            <a style={{opacity: 0.5, color: '#EF4848', cursor: 'default'}}>Cancel</a>
                            <a style={{color: '#EF4848', cursor: 'pointer'}}
                               onClick={() => this.handleDeletePhoneNumber(item.id)}>Delete {this.state.deletePhoneLoader ?
                                <i className='fa fa-spin fa-spinner'></i> : ''}</a>
                        </div>
                    </Popover>
                </div>
        }</Cell>
    };

    /* Loading Cell */
    threeDotsCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            <div className="bp3-skeleton" style={{width: 100, height: 20}}/>
        </Cell>
    };

    getNumbers = async () => {
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        if (user && user.id && projectId && this.state.selectedTab === 'Active Numbers') {
            try {
                // this.setState({loader: false})
                await this.setState({loader: true, user, deletePhoneId: ''})

                // const result = await http.post('/api/project/' + projectId + '/phones_incoming', {headers: {authorization: getJwt()}});
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/project_phones', {headers: {authorization: getJwt()}});

                // await console.log('Evo ga rezultat za getNumbers: ', [result.data.phone_number_prices])

                await this.setState({
                    selectedSource: projectId,
                    // numbers: [result.data.phone_number_prices],
                    numbers: result.data.project_phones,
                    loader: false
                })
                if (!this.state.numbers) {
                    this.setState({loader: false})
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: '', rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        } else if (user && user.id && projectId && this.state.selectedTab === 'Test Numbers') {
            try {
                // this.setState({loader: false})
                await this.setState({loader: true, user, deletePhoneId: ''})

                // const result = await http.post('/api/project/' + projectId + '/phones_incoming', {headers: {authorization: getJwt()}});
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/verified_phones/page_size/' +
                    this.state.pageSize + '?page=' + this.state.selectedPage, {headers: {authorization: getJwt()}});

                // await console.log('Evo ga rezultat za getNumbers: ', [result.data.phone_number_prices])

                await this.setState({
                    selectedSource: projectId,
                    // numbers: [result.data.phone_number_prices],
                    numbers: result.data.verified_phones,
                    totalNumbers: result.data.total_contacts,
                    loader: false
                })
                // console.log('this.state.numbers: ', result.data, this.state.numbers, this.state.totalNumbers)
                if (!this.state.numbers) {
                    this.setState({loader: false})
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: '', rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

    }

    recalculateColsWidth = async (tableTotalWidth) => {
        let containerWidth = this.props.size.width;
        let lastWidth = (containerWidth - tableTotalWidth) > 0 ? (containerWidth - tableTotalWidth) : 150;

        if ((this.state.lastColumnWidth !== lastWidth) && (lastWidth > 0) && containerWidth > 0) {
            await this.setState({lastColumnWidth: lastWidth > 120 ? lastWidth : 120})
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        }
    }

    handleDeletePhoneNumber = (id) => {
        this.setState({deletePhoneId: id, showDeletePhoneModal: true})
    }

    handleVerifyNumber = (existingNumberData) => {
        this.setState({
            existingNumberData,
            verifyNumberModalActive: true
        })
    }

    getMuiTheme = () => createTheme({
        typography: {
            htmlFontSize: 12,
            fontFamily: 'Poppins',
            color: '#344A5E'
        },
        overrides: {
            MuiPaper: {
                elevation4: {
                    boxShadow: 'none',
                    border: '1px solid #D6DBDF'
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    fontWeight: 600
                    // backgroundColor: "blue"
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    fontWeight: 600
                    // backgroundColor: "blue"
                }
            },
            MuiTableRow: {
                root: {
                    '&:nth-child(odd)': {
                        backgroundColor: '#FAFAFA'
                    }
                },
                hover: {
                    "&:hover": {
                        backgroundColor: "rgba(38, 170, 225, 0.2) !important"
                    }
                },
                // selected: {
                //     "&:hover": {
                //         backgroundColor: "#26AAE1 !important"
                //     }
                // }
            },
            MuiIconButton: {
                label: {
                    // fontSize: 30
                    // color: "#344A5E"
                }
            },
            MUIDataTableSelectCell: {
                fixedLeft: {
                    zIndex: 1
                },
                root: {},
                checkboxRoot: {
                    color: "#D6DBDF !important",
                },
                checked: {
                    color: "#344A5E !important"
                },
            },
            MUIDataTableToolbarSelect: {
                root: {
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingRight: 20,
                    paddingLeft: 20,
                    backgroundColor: '#fff',
                    boxShadow: 'none',
                    zIndex: 1
                }
            },
            MuiTooltip: {
                tooltip: {
                    fontSize: 12,
                }
            },
            MuiInput: {
                underline: {
                    "&:after": {
                        borderBottom: '2px solid #18A9E3'
                    }
                }
            },
            MUIDataTableToolbar: {
                icon: {
                    "&:hover": {
                        color: '#18A9E3'
                    }
                },
                iconActive: {
                    color: '#18A9E3'
                }
            },
            MuiCheckbox: {
                colorPrimary: {
                    "&.Mui-checked": {
                        color: '#344A5E'
                    }
                }
            },
            MuiChip: {
                root: {
                    borderRadius: 4
                }
            },
            MuiButton: {
                textPrimary: {
                    color: '#18A9E3'
                }
            }
        }
    })

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    handleTabSelected = tab => {
        this.setState({selectedTab: tab})
        if (tab === 'Active Numbers') {
            this.getNumbers()
        } else if (tab === 'Test Numbers') {
            this.getNumbers()
        } else {
            this.setState({
                numbers: []
            })
        }
    }

    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.props.turnOffTour()
        }

    }

    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };
    handleToggle = async item => {
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        // console.log('item: ', item)
        if (item.webhook) {
            let resp = await http.post('api/project/' + item.project_id + '/phone_disable_webhook/' + item.id, {}, {headers: {authorization: getJwt()}});
            this.getNumbers();
        } else {
            let resp = await http.post('api/project/' + item.project_id + '/phone_update/' + item.id, {}, {headers: {authorization: getJwt()}});
            this.getNumbers();
        }

    }

    handleRowsPerPageChange = (number) => {
        this.setState({pageSize: number});
        this.getNumbers()
    };

    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);
        /* Setting the width of the content container for calculating lastColumnWidth */
        await this.setState({width: this.container.offsetWidth, selectedSource: this.props.selectedSource});
        await this.getNumbers()
    }

    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({selectedSource: this.props.selectedSource})
            await this.getNumbers()
        }
        if (this.state.tourRun !== this.props.tourRun) {
            this.setState({
                tourRun: this.props.tourRun
            })
        }
    }

    render() {
        const columns = [
            {
                name: "friendly_name",
                label: "Name",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "phone_number",
                label: "Phone Number",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "phone_type",
                label: "Type",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "none",
                label: "Enable 2-Way",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.numbers[tableMeta.rowIndex];

                        return <BlueprintSwitch
                            checked={item.webhook}
                            label=""
                            onChange={() => this.handleToggle(item)}
                            style={{marginBottom: 0}}
                        />
                    }
                }
            },
            {
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return <div className='flex-end'>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                minimal={true}
                            >
                                <span id="feed-edit" className="fas fa-ellipsis-v margin-right-10"></span>
                                <div className="project-info-popover padding-10">
                                    <a style={{opacity: 0.5, color: '#EF4848', cursor: 'default'}}>Cancel</a>
                                    <a style={{color: '#EF4848', cursor: 'pointer'}}
                                       onClick={() => this.handleDeletePhoneNumber(value)}>Delete</a>
                                </div>
                            </Popover>
                        </div>
                    }
                }
            },
        ];

        const columnsTestNumbers = [
            {
                name: "friendly_name",
                label: "Name",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "phone_number",
                label: "Phone Number",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "number_verified",
                label: "Verified",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.numbers[tableMeta.rowIndex];
                        return <Tag
                            className={item.verified && item.verified === 1 ? 'bp3-intent-success no-border' : 'bp3-intent-danger no-border'}>
                            {item.verified && item.verified === 1 ? 'Verified' : 'Not Verified'}
                        </Tag>
                    }
                }
            },
            {
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.numbers[tableMeta.rowIndex];
                        return <div className='flex-end'>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}
                                popoverClassName="bp3-popover-content-sizing"
                                position={Position.LEFT_TOP}
                                minimal={true}
                            >
                                <span id="feed-edit" className="fas fa-ellipsis-v margin-right-10"></span>
                                <div className="project-info-popover">
                                    {!item.verified ?
                                        <a
                                            style={{
                                                color: '#ffb347',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => this.handleVerifyNumber(item)}>Verify</a>
                                        :
                                        ''
                                    }
                                    <a style={{color: '#EF4848', cursor: 'pointer'}}
                                       onClick={() => this.handleDeletePhoneNumber(value)}>Delete</a>
                                </div>
                            </Popover>
                        </div>
                    }
                }
            },
        ];

        const options = {
            onSearchChange: (text) => this.handleSearchContacts(text),
            onSearchClose: this.handleSearchContactsClose,
            searchText: this.state.searchTerm,
            serverSide: true,
            selectableRows: 'none',
            viewColumns: false,
            count: this.state.totalNumbers,
            tableFooter: false,
            filterType: 'checkbox',
            rowsPerPage: this.state.pageSize,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            print: false,
            search: false,
            filter: false,
            download: false,
            sort: false,
            rowsPerPageOptions: [5, 25, 50, 100],
            textLabels: {
                body: {
                    noMatch: this.state.tableLoader ?
                        this.tableLoaderRenderer()
                        :
                        <p>You don’t have any {this.state.selectedTab}. {this.state.selectedTab === 'Test Numbers' ?
                            <a onClick={() => this.setState({verifyNumberModalActive: true})}>Verify New Number</a>
                            :
                            <a onClick={() => this.props.history.push('/phone-numbers')}>{ this.props.selectedSourceNode.free_phone_to_claim ?
                                'Claim Free US Phone' : 'Buy a Number'
                            }</a>}
                        </p>
                },
            },

        };
        const {
            sources,
            //feeds_shared,
            updateUser, updateSources, selectSource, selected_source
        } = this.props;

        const {steps, tourRun} = this.state
        let projectId = this.props.selectedSource ? this.props.selectedSource : JSON.parse(localStorage.source_clicked);

        let selectedSourceData = sources && sources.length ? sources.find(source => source.id.toString() === projectId.toString()) : '';
        let freePhoneToClaim = this.props.selectedSourceNode.free_phone_to_claim;
        //let selectedFeedSharedData = feeds_shared && feeds_shared.length ? feeds_shared.find(feed => feed.project_id.toString() === projectId.toString()) : ''

        // let alphanumericId = selectedSourceData && selectedSourceData.alphanumeric_id ? selectedSourceData.alphanumeric_id :
        //     selectedFeedSharedData && selectedFeedSharedData.alphanumeric_id ? selectedFeedSharedData.alphanumeric_id : '';
        let alphanumericId = selectedSourceData.alphanumeric_id
        return (

            <div className="channel-container sms-pool-tour-step-1 sms-pool-tour-step-4"
                 ref={el => (this.container = el)}>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={tourRun}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />

                <div className="channel-heading-container">

                    <h3 className='m-lg-b'>SENDER POOL</h3>
                    <div>
                        <p style={{cursor: "pointer", marginBottom: 0}}><span
                            className='enabled-label'>Enabled </span>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                minimal={true}
                            >
                                <span className="fas fa-ellipsis-v" style={{color: 'black', marginLeft: 10}}></span>
                                <div className="three-dots-popover padding-10">
                                    <a id="team_delete_btn" onClick={() => console.log('Disable clicked')}
                                       href="#">Disable {this.state.fb_spinner ?
                                        <i className='fa fa-spin fa-spinner'></i> : ''}</a>
                                </div>
                            </Popover></p>

                    </div>
                </div>
                <div className='space-between'>
                    <p>Emitto lets you send SMS messages to your contacts in more than 150 countries worldwide.</p>
                    {/*<p className='grey-text'>Need help figuring out what you need?</p>*/}
                </div>
                <Callout icon='info-sign' intent={Intent.PRIMARY}>
                    Depending on the destination countries of your contacts, you will need to set up the <strong>Alphanumeric
                    ID</strong>,
                    or buy <strong>dedicated phone numbers</strong> or <strong>short-codes</strong>. Make sure to check
                    out the <strong>Knowledge Base</strong> for more
                    details on the setup required for specific countries.
                </Callout>
                <div className='alphanumeric-fields-container'>
                    <div className='full-field-container sms-pool-tour-step-2'>
                        <h3>Alphanumeric ID <InfoCircle
                            icon={'question-grey'}
                            infoCircleContent={
                                <p className='info-circle-content'>Alphanumeric Sender ID
                                    allows you to send messages to supported countries from a
                                    personalized Sender ID (like a business or organization name), instead of your E.164
                                    formatted Emitto Phone number.<br/>
                                    Some of the countries requires pre-registrations.
                                </p>
                            }
                        /></h3>
                        <p>Sender Name: <strong data-intercom-target="sms-alphanumeric-id">{alphanumericId}</strong></p>
                        <a target='_blank' href='https://emitto.io/sms-alphanumeric-availability/'>See full list of
                            supported countries.<br/></a>
                        <div className='display-flex flex-direction-row'>
                            {this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                            this.props.selectedSourceNode.business_verification.status === 'verified' ?
                                <button className='btn-action margin-top-20'
                                        onClick={() => this.setState({editSenderNameModal: true})}>Edit Sender Name
                                </button>
                                :
                                <Popover
                                    interactionKind={PopoverInteractionKind.HOVER}
                                    position={Position.TOP}
                                >
                                    <button className='btn-action margin-top-20' disabled={true}>Edit Sender Name</button>
                                    <p className='padding-10'>You need to verify your business before being able to
                                        choose a different sender ID.</p>
                                </Popover>
                            }
                            <a href='https://emitto.io/sms-new-sender-name/' target='_blank'>
                                <Popover
                                    interactionKind={PopoverInteractionKind.HOVER}
                                    position={Position.TOP}
                                >
                                    <button className='btn-green'>
                                        Request Sender Registration
                                    </button>
                                    <p className='padding-10'>In order to have your Brand name delivered as the Sender
                                        ID registration is required with all local carriers.</p>
                                </Popover>
                            </a>
                        </div>


                        <EditAlphanumericIdModal
                            showModal={this.state.editSenderNameModal}
                            handleClose={() => this.setState({editSenderNameModal: false})}
                            maxWidth={600}
                            history={this.props.history}
                            user={this.props.user}
                            updateUserFromServer={this.props.updateUserFromServer}
                            alphanumericId={alphanumericId}
                        />
                    </div>
                    {/*<div className='field-container'>*/}
                    <div className='full-field-container'>
                        <h3>Phone Numbers <InfoCircle
                            icon={'question-grey'}
                            infoCircleContent={
                                <p className='info-circle-content'>Standard phone numbers used to send and receive SMS
                                    messages.</p>
                            }
                        /></h3>
                        <p>Used worldwide.</p>
                        <button className='btn-green sms-pool-tour-step-3'
                                onClick={() => this.props.history.push('/phone-numbers')}
                        >
                            Buy Phone Numbers
                        </button>
                        {freePhoneToClaim ?
                            <button className='btn-action margin-top-20'
                                    onClick={() => this.props.history.push('/phone-numbers')}
                            >
                                Claim Free US Phone
                            </button>
                            :
                            ''
                        }


                        {/*<Tooltip className={Classes.TOOLTIP_INDICATOR} content={'Coming Soon'}>*/}
                        {/*<button disabled={true} className='btn-transparent-border' style={{marginBottom: 5}}>Port a Number</button>*/}
                        {/*</Tooltip>*/}

                    </div>
                    {/*<div className='field-container'>*/}
                    {/*<h3>Short Codes  <InfoCircle*/}
                    {/*icon={'question-grey'}*/}
                    {/*infoCircleContent={*/}
                    {/*<p className='info-circle-content' >Here goes text...</p>*/}
                    {/*}*/}
                    {/*/></h3>*/}
                    {/*<p>Used to send messages in US, Canada, UK.</p>*/}

                    {/*<Tooltip className={Classes.TOOLTIP_INDICATOR} content={'Coming Soon'}>*/}
                    {/*<button disabled={true} className='btn-action margin-top-20' style={{marginBottom: 5}}>Buy Short Codes</button>*/}
                    {/*</Tooltip>*/}
                    {/*</div>*/}
                    <div className="tabs-navigation margin-top-20">
                        <div
                            onClick={() => this.handleTabSelected('Active Numbers')}
                            className={this.state.selectedTab === 'Active Numbers' ? "navigation-tab active" : "navigation-tab"}
                        >
                            <p>Active Numbers</p>
                        </div>
                        {/*<div*/}
                        {/*    onClick={() => this.handleTabSelected('Released Numbers')}*/}
                        {/*    className={this.state.selectedTab === 'Released Numbers' ? "navigation-tab active" : "navigation-tab"}*/}
                        {/*>*/}
                        {/*    <p>Released Numbers</p>*/}
                        {/*</div>*/}
                        <div
                            onClick={() => this.handleTabSelected('Test Numbers')}
                            className={this.state.selectedTab === 'Test Numbers' ? "navigation-tab active" : "navigation-tab"}
                        >
                            <p>Test Numbers</p>
                        </div>
                        {/*<div*/}
                        {/*    onClick={ () => {this.setState({selectedTab: 'Verified Caller IDs'})}}*/}
                        {/*    className={ this.state.selectedTab === 'Verified Caller IDs' ? "navigation-tab active" : "navigation-tab"}*/}
                        {/*>*/}
                        {/*    <p>Verified Caller IDs</p>*/}
                        {/*</div>*/}
                    </div>
                    <div className='sms-tables-container'>
                        {this.state.selectedTab === 'Test Numbers' ?
                            <div className='space-between flex-direction-row'>
                                <h3>{this.state.selectedTab}</h3>
                                <button
                                    disabled={this.state.numbers && this.state.numbers.length && this.state.numbers.length > 4}
                                    onClick={() => this.setState({verifyNumberModalActive: true})}
                                    className='btn-action btn-small'
                                >
                                    Verify New Number
                                </button>
                            </div>
                            :
                            <h3>{this.state.selectedTab}</h3>
                        }


                        {
                            this.state.loader ?
                                this.tableLoaderRenderer()
                                :
                                <MuiThemeProvider theme={this.getMuiTheme()}>
                                    <MUIDataTable
                                        title={""}
                                        data={this.state.numbers}
                                        columns={this.state.selectedTab === 'Test Numbers' ? columnsTestNumbers : columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                        }
                    </div>
                </div>
                <DeletePhoneModal
                    user={this.props.user}
                    showModal={this.state.showDeletePhoneModal}
                    deleteVerifiedPhone={this.state.selectedTab === 'Test Numbers'}
                    handleClose={() => this.setState({showDeletePhoneModal: false})}
                    projectId={this.props.selected_source}
                    maxWidth={600}
                    getNumbers={this.getNumbers}
                    phoneId={this.state.deletePhoneId}
                />
                <VerifyNumberModal
                    showModal={this.state.verifyNumberModalActive}
                    handleClose={() => this.setState({verifyNumberModalActive: false, existingNumberData: ''})}
                    selectedSource={this.props.selectedSource}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updateUserFromServer={this.props.updateUserFromServer}
                    handleGetNumbers={this.getNumbers}
                    existingNumberData={this.state.existingNumberData}
                />
            </div>
        )

    }
}


export default sizeMe()(SmsChannelSenderPool);